export default {
    getHeaderFieldsDBNO: state => state.headerFieldsDBNO,
    getFormActionsDBNO: state => state.formActionsDBNO,
    getActionsDBNO: state => state.actionsDBNO,
    getRowActionsDBNO: state => state.rowActionsDBNO,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen
}
